import { Component } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(router: Router) {  };
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts